export default __webpack_public_path__ + "static/media/SIW100G_M010_W00.ae8eb49c.webp";